var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPricesXlm(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 40,
    viewBox: "0 0 40 40",
    width: 40,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    fill: "#000",
    height: 40,
    rx: 20,
    width: 40,
    y: 0
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m30.3616 11.1403-3.413 1.7406-16.4932 8.4002c-.235-1.8052.0361-3.6402.7832-5.3003.747-1.66 1.9406-3.0799 3.4476-4.1012 1.5069-1.0213 3.268-1.6039 5.0867-1.6827s3.6236.3492 5.2132 1.2363l1.954-.9954.2915-.1493c-1.8537-1.3452-4.0535-2.13184-6.3398-2.26707-2.2864-.13523-4.5636.38659-6.5629 1.50385-1.9993 1.11722-3.6372 2.78332-4.72019 4.80132-1.08299 2.0181-1.5659 4.3039-1.39169 6.5876.0326.4295-.06262.8591-.27367 1.2347-.21105.3755-.52849.6802-.91235.8757l-1.031.5261v2.4517l3.03471-1.5472.98269-.502.9684-.4935 17.3863-8.8595 1.9539-.994 4.0387-2.0578v-2.45022zm4.0045 2.8612-22.3905 11.3994-1.954.9954-4.02018 2.0521v2.4502l3.99319-2.0336 3.41439-1.7406 16.5103-8.413c.2386 1.808-.0307 3.6467-.7778 5.3103-.747 1.6636-1.9423 3.0864-3.4521 4.1093-1.5098 1.0228-3.2744 1.6053-5.0964 1.6822s-3.6295-.3548-5.2201-1.2468l-.1209.064-2.1189 1.0808c1.854 1.3459 4.0544 2.133 6.3414 2.2683 2.287.1354 4.5649-.3868 6.5647-1.5046 1.9997-1.1179 3.6377-2.7848 4.7204-4.8038s1.5649-4.3057 1.3895-6.5899c-.0322-.4292.063-.8583.2738-1.2335.2107-.3752.5276-.6797.9108-.8755l1.0324-.5262v-2.4431z",
    fill: "#fff"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPricesXlm);
export default __webpack_public_path__ + "static/media/prices-xlm.071159f57838b4b7d57e0186c2d7f7f4.svg";
export { ForwardRef as ReactComponent };